import Link from "next/link";
import { colors, radius, shadow } from "@/styles/theme";

const PRINCIPLES = [
  {
    eyebrow: "No feed algorithm",
    text: "What you follow is what you see. Nothing injected because it performs well, nothing withheld to keep you scrolling.",
  },
  {
    eyebrow: "Ranking that serves you",
    text: "Places are ordered by ratings from people who've actually visited - never by who paid.",
  },
  {
    eyebrow: "Advertising with real limits",
    text: "No interruptions, no full-screen takeovers, no tracking that follows you around the internet. Ever.",
  },
  {
    eyebrow: "We sell context, not you",
    text: "An advertiser can reach a region or a route. They can never reach you specifically - we don't build a profile to sell.",
  },
  {
    eyebrow: "Notifications you control",
    text: "Follow precisely, set your own frequency, leave in one tap. No dark patterns designed to make leaving harder.",
  },
  {
    eyebrow: "Your documents never touch us",
    text: "Verification runs through an independent provider. What we keep is a flag - verified, or not. Nothing else.",
  },
  {
    eyebrow: "A real moderator",
    text: "A vetted person, not a bot left unattended. Reports are read by a human and actioned.",
  },
  {
    eyebrow: "Reach without exploitation",
    text: "If your friends follow your journey, they hear from it. We don't throttle it to sell it back.",
  },
];

export function PrinciplesShowcase() {
  return (
    <section style={{ marginTop: "28px", width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          flexWrap: "wrap",
          gap: "8px",
          marginBottom: "12px",
        }}
      >
        <h2 style={{ fontSize: "16px", margin: 0, color: colors.textPrimary }}>How we build</h2>
        <Link href="/about" style={{ fontSize: "12px", color: colors.accentStart, textDecoration: "none", fontWeight: 600 }}>
          Read the full statement &rarr;
        </Link>
      </div>

      <div
        style={{
          display: "flex",
          gap: "12px",
          overflowX: "auto",
          paddingBottom: "6px",
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
        }}
      >
        {PRINCIPLES.map((p) => (
          <div
            key={p.eyebrow}
            style={{
              flex: "0 0 auto",
              width: "220px",
              scrollSnapAlign: "start",
              background: colors.cardBg,
              border: `1px solid ${colors.border}`,
              borderRadius: radius.lg,
              boxShadow: shadow.card,
              padding: "16px",
            }}
          >
            <p style={{ fontSize: "12px", fontWeight: 700, color: colors.accentStart, margin: "0 0 6px" }}>
              {p.eyebrow}
            </p>
            <p style={{ fontSize: "12px", color: colors.textSecondary, lineHeight: 1.5, margin: 0 }}>{p.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
